import { useEffect, useState } from 'react';

import { getInjector } from '@/services/angularjs-bridge';

const useDataModelResource = () => {
    // eslint-disable-next-line
    const [dataModelResource, setDataModelResource] = useState<any>();
    useEffect(() => {
        const angularJsInjector = getInjector();
        const dataModelResource = angularJsInjector.get('UseDatamodelResource');
        setDataModelResource({ ...dataModelResource });
    }, []);
    return { dataModelResource };
};

export default useDataModelResource;
